module.exports = __webpack_public_path__ + "static/gold-gift-0b833676ea4dbcee77361113c982729e.webp";